import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import { getReservoirAuthToken } from '../../../services/vu'
import Loading from '../../pages/Loading'

class ReservoirAuthToken extends Component {
  constructor(props) {
    super(props)

    this.state = {
      attemptedToLoadAuthToken: false
    }
  }

  componentDidMount() {
    getReservoirAuthToken().then(() => {
      this.setState({
        attemptedToLoadAuthToken: true
      })
    })
  }

  render() {
    if (this.state.attemptedToLoadAuthToken) {
      return this.props.children
    }
    return <Loading/>
  }
}

export default withRouter(ReservoirAuthToken)
